import { ReactNode } from 'react';

import { ChakraText, EquipUITheme } from '@equip.health/ui';

const { label } = EquipUITheme.typography;

const Label = ({ children, id }: { children: ReactNode; id: string }) => {
  return (
    <ChakraText
      {...label}
      color="neutral.secondary"
      id={`${id}-label`}
      lineHeight="16.8px"
      paddingBottom="11.5px"
    >
      {children}
    </ChakraText>
  );
};

export default Label;
